import { useState } from 'react'
import './CollapsibleSection.scss'

interface CollapsibleSectionProps {
  title: string
  children: React.ReactNode
  isOpen?: boolean
  onToggle?: () => void
  defaultOpen?: boolean
  isMobile: boolean
}

function CollapsibleSection({
  title,
  children,
  isOpen: controlledIsOpen,
  onToggle,
  defaultOpen = true,
  isMobile,
}: CollapsibleSectionProps) {
  const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen)

  // Use controlled state if provided, otherwise use internal state
  const isOpen =
    controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen

  const handleToggle = () => {
    if (onToggle) {
      onToggle()
    } else {
      setInternalIsOpen(!internalIsOpen)
    }
  }

  return (
    <div
      className={`collapsible-section ${isMobile ? 'collapsible-section-mobile' : ''}`}
    >
      <div className="collapsible-section-header" onClick={handleToggle}>
        <span
          className={`collapsible-section-title ${isMobile ? 'collapsible-section-title-mobile' : ''}`}
        >
          {title}
        </span>
        <span className={`collapsible-section-icon ${isOpen ? 'open' : ''}`}>
          ▼
        </span>
      </div>
      <div
        className={`collapsible-section-content ${isMobile ? 'collapsible-section-content-mobile' : ''} ${isOpen ? 'open' : ''}`}
      >
        <div className="collapsible-section-content-inner">{children}</div>
      </div>
    </div>
  )
}

export default CollapsibleSection
